import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { BaseComponent } from 'src/core/controls/base.component';
import { ShareDataService } from 'src/providers/sharedata.service';
import { OrderService } from 'src/services/order.service';
import { ShareModule } from '../share.module';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss'],
})
export class PortalComponent extends BaseComponent implements OnInit  {
  title: string = "Digital-Menu Portal";
  selected: string;
  printed: string;
  
  cWebsite: string;
  cLink: boolean=true;

  // LogoFormControl = new FormControl('');

  options = [
    { name: "Logo", value: 1 },
    { name: "Goods", value: 2 },
    { name: "Slider", value: 3 },
    { name: "social media", value: 4 }
  ]

  links: object[] = [
    {name: 'کد گروه کالا'},
    {name: 'کد لیست کالا'}
  ];
  canChange = true;
  isFinish: boolean = true;

  activeLink = this.links[0];
  background: ThemePalette = undefined;
  
  constructor(
    public shared: ShareModule,
    public share: ShareDataService,
    private order: OrderService,
    private spinner: NgxUiLoaderService) {
      super();
    }

  ngOnInit(): void {
    this.share.lastUrl = 'portal';

        this.isSiteOnline("https://imageresizer.com/image-compressor",found =>{
          if(found) {
              // site is online
              this.cWebsite = "https://imageresizer.com/image-compressor";
          }
          else {
              this.cWebsite= "https://www.freeconvert.com/image-converter";
          }
        });
  }

  setActiveTab(event: any) {
    if (event === 1)
      this.share.hasSwitchTabIndex = true;
    switch (this.share.selectedtab) {
      case 0: // index of the tab
        this.router.navigate(['/portal/logo']);
        break;
      case 1:
        this.router.navigate(['/portal/goods']);
        break;
      case 2:
        this.router.navigate(['/portal/slider']);
        break;
      case 3:
          this.router.navigate(['/portal/social']);
        break;
    }
    this.imageCompressor();
  }

  onSelect(evt: any) {
    this.selected = evt.value;
    console.log(this.selected);
  }

  imageCompressor() {    
    switch (this.share.selectedtab) {
      case 3:
        this.cLink = false;
        break;
      default:
        this.cLink = true;
        break;
    }    
  }

  isSiteOnline(url,callback) {
    // try to load favicon
    var timer = setTimeout(function(){
        // timeout after 5 seconds
        callback(false);
    },5000)

    var img = document.createElement("img");
    img.onload = function() {
        clearTimeout(timer);
        callback(true);
    }

    img.onerror = function() {
        clearTimeout(timer);
        callback(false);
    }

    img.src = url+"/favicon.ico";
  }

}
